import { number, string, object } from '@gogame/schemas';

import {
  INVOICE_AMOUNT,
  INVOICE_CURRENCY_CODE,
  INVOICE_TYPE,
} from '../constants';
import { CREDIT_MEMO } from './constants';

export const invoiceSchema = object({
  [INVOICE_TYPE]: number().required('Invoice type is required'),
  [INVOICE_CURRENCY_CODE]: string().required('Currency is required'),
  [INVOICE_AMOUNT]: number()
    .required('Invoices amount is required')
    .when(INVOICE_TYPE, (invoiceType, schema) => {
      return invoiceType === CREDIT_MEMO
        ? schema.lessThan(0, 'Invoices amount must be < 0')
        : schema.min(1, 'Invoices amount must be > 1');
    }),
});
